import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Box,
  Switch,
} from '@material-ui/core';

import addForAdmin from '../../../../../images/addForAdmin.svg'

import {getPointsByQuizz} from "../../../../../contexts/UserContext"
import SuperAdminContext from "../../../../../contexts/SuperAdminContext"

const DiagHelper = ({ format, results, setResults, stepIndex, categoriesIndexes, actFormation, actIndex }) => {

  const superAdminContext = useContext(SuperAdminContext)

  const addStep = () => {
    var data =format?.total
    data.push({ seuil: 0, title: null, text: 'Vous êtes sur le bon chemin...'})

    superAdminContext?.onSequenceChange(
      'total',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }
  const handleStepSeuil = (value, i) => {
    var data = format?.total
    data[i].seuil = value

    superAdminContext?.onSequenceChange(
      'total',
      data,
      superAdminContext?.adminPlayerIndexes
    )

    //on doit aussi MAJ le score
    if (results) {
      let findInResults = results["master"]
      if (findInResults) {
        results.master.score = value
        setResults(results)
      }
    }
  }
  const removeStep = (i) => {
    var data = format?.total
    data.splice(i, 1)

    superAdminContext?.onSequenceChange(
      'total',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }
  const updateSeuilOrder = () => {
    var data = format?.total
    data.sort((a,b)=>(b.seuil - a.seuil))
    superAdminContext?.onSequenceChange(
      'total',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const [allCats, setAllCats] = useState([])
  useEffect(() => {
    if (actFormation) {
      let categories = {master: { max: 0 }}
      if (format?.isChapter === true) {
        categories.glbMaster = { max : 0}
      }

      let glbMasterPond = []
      if (actFormation?.glbMasterPond !== null) {
        glbMasterPond = JSON.parse(actFormation?.glbMasterPond)
      }

      const manageFormat = (format) => {
        if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
          const [points, max] = getPointsByQuizz(format)
          const makeResult = (c, max) => {
            let newMax = c.max+max
            return { max : newMax }
          }
          categories.master = makeResult(categories.master, max)
          if (format.categorie && format.categorie !== 'master') {
            categories[format.categorie] = makeResult(categories[format.categorie] ?? { max: 0, score: 0  }, max)
          }
        }
      }

      const manageFormatGlb = (format) => {
        if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
          const [points, max] = getPointsByQuizz(format)
          const makeResult = (c, max) => {
            //on cherche si la categorie est à ignorer ou non
            let statut = "oui"
            let find = glbMasterPond.find((el) => el.key === format.categorie)
            if (find) {
              statut = find.value
            }
            if (statut === "oui") {
              let newMax = c.max+max
              return { max : newMax }
            } else {
              return { max : c.max }
            }
          }
          categories.glbMaster = makeResult(categories.glbMaster, max)
        }
      }

      if (format?.isChapter === true) {
        //master glb
        if (actFormation) {
          for (var c in actFormation?.chapitre) {
            for (var i in actFormation?.chapitre[c]?.partie) {
              for (var n in actFormation?.chapitre[c]?.partie[i]?.sequence) {
                manageFormatGlb(actFormation?.chapitre[c]?.partie[i]?.sequence[n])
              }
            }
          }
        }
        //master + autres catégories
        const parts = actFormation?.chapitre[actIndex?.chapitre]?.partie
        for (var i in parts) {
          for (var n in parts[i].sequence) {
            manageFormat(parts[i].sequence[n])
          }
        }
      } else {
        let actPart = actFormation?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]
        for (var i = actIndex?.sequence - 1; i >= 0; i--) {
          manageFormat(actPart?.sequence[i])
        }
      }

      setAllCats(categories)
    }
  }, [format?.isChapter])

  const handleCheckbox = (e) => {
    var cats = [...format?.categorie];
    const key = e.target.name
    if(cats.filter(c => c.key == key).length > 0){
      for( var i = 0; i < cats.length; i++)if ( cats[i].key == key) cats.splice(i, 1);
    }else{
      cats.push( {key: key, title: null, position: cats.length, seuils: [{ seuil: 0, text: null}]})
    }
    for( var i = 0; i < cats.length; i++) cats[i].position = i

    superAdminContext?.onSequenceChange(
      'categorie',
      cats,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const addCategoryStep = (iCat) => {
    var data = format?.categorie
    data[iCat].seuils.push({ seuil: 0, text: null})

    superAdminContext?.onSequenceChange(
      'categorie',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const removeCategoryStep = (iCat, iStep) => {
    var data = format?.categorie
    const cat = data[iCat]
    data[iCat].seuils.splice(iStep, 1)

    superAdminContext?.onSequenceChange(
      'categorie',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const updateCatOrder = (iCat) =>{
     var data = format?.categorie
     data[iCat].seuils.sort((a,b)=>(b.seuil - a.seuil))

     superAdminContext?.onSequenceChange(
       'categorie',
       data,
       superAdminContext?.adminPlayerIndexes
     )
  }

  const handleCategorieSeuil = (value, iCat, iStep) => {
    var data = format?.categorie
    data[iCat].seuils[iStep].seuil = value

    superAdminContext?.onSequenceChange(
      'categorie',
      data,
      superAdminContext?.adminPlayerIndexes
    )


    //on doit aussi MAJ le score
    let actKey = data[iCat]?.key
    if (results && actKey) {
      let findInResults = results[actKey]
      if (findInResults) {
        results[actKey].score = value
        setResults(results)
      }
    }
  }

  return (
    <>
      <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Type</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px",}}>
        <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Switch
            sx={{marginLeft:"-5px"}}
            checked={format?.isChapter?true:false}
            onChange={(e) => {
              superAdminContext?.onSequenceChange(
                'isChapter',
                e.target.checked,
                superAdminContext?.adminPlayerIndexes
              )
            }}
            size="small"
            color="warning"
          />
          Diagnostic de chapitre
        </Box>
      </Box>
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Titre ("master")</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px",}}>
        {format?.total?.map((step, i) => {
          return (
            <Box
              sx={{
                display:"flex",
                alignItems:"center",
                justifyContent:"space-between",
                borderBottom:"1px solid #BABABA",
                "&:hover" : {
                  ".svgDelete" : {
                    opacity: "1 !important"
                  }
                }
              }}
              key={i}
            >
              <Box sx={{
                paddingTop:"2px",
                paddingBottom:"2px",
                display:"flex",
                alignItems:"center"
              }}>
                <svg
                  style={{fill : i === stepIndex ? "green" : "silver", cursor:"pointer"}}
                  onClick={() => {
                    let newResults = {...results}
                    newResults["fakeMasterForTitle"].score = step?.seuil
                    setResults(newResults)
                  }}
                  width="20" height="20" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m348.41 504.58c186.98 0 342.3-182.57 342.3-182.57 12.148-13.004 12.488-34.48 0.38281-47.59 0 0-147.64-182.07-341.07-182.07-193.43 0-341.07 182.07-341.07 182.07-11.938 13.281-12 34.836 0.21094 47.789 0 0 152.27 182.37 339.25 182.37zm1.6133-60.621c80.121 0 145.07-65.137 145.07-145.49 0-80.352-64.953-145.49-145.07-145.49-80.125 0-145.07 65.141-145.07 145.49 0 80.352 64.949 145.49 145.07 145.49zm0-80.828c35.609 0 64.477-28.949 64.477-64.66 0-35.711-28.867-64.664-64.477-64.664-35.609 0-64.48 28.953-64.48 64.664 0 35.711 28.871 64.66 64.48 64.66z" fillRule="evenodd"/>
                </svg>
                <span style={{fontSize:"14px", marginLeft:'7px'}}> ≥ : </span>
                <input
                  value={step?.seuil}
                  style={{marginLeft:"7px", fontSize:"12px", marginRight:"3px", width:"42px"}}
                  type="number"
                  onBlur={updateSeuilOrder}
                  onChange={(e) => {
                    handleStepSeuil(e.target.value ? parseInt(e.target.value): 0,i)
                  }}
                />
                <span>%</span>
              </Box>
              {format?.total?.length > 2 &&
                <svg className="svgDelete" style={{fill:"silver", opacity:0, cursor:"pointer"}} onClick={()=> {removeStep(i)}} width="20" height="20" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" >
                  <path d="m491.51 177.63h-283.02c-4.8047-0.03125-9.3945 1.9961-12.605 5.5742-3.2148 3.5742-4.7383 8.3555-4.1953 13.129l28 244.5c2.0234 17.77 10.516 34.176 23.859 46.086 13.348 11.906 30.609 18.488 48.492 18.48h120.57c18.113 0 35.574-6.7539 48.973-18.945 13.402-12.188 21.777-28.934 23.488-46.965l23.188-243.49c0.44141-4.7188-1.1328-9.4062-4.332-12.906s-7.7305-5.4844-12.469-5.4609z"/>
                  <path d="m424.48 93.801c0-10.398-4.1289-20.367-11.48-27.719-7.3516-7.3516-17.324-11.48-27.719-11.48h-70.562c-10.395 0-20.367 4.1289-27.719 11.48-7.3516 7.3516-11.48 17.32-11.48 27.719v14.785h-124.77v33.602l398.49-0.003906v-33.602l-124.77 0.003907zm-33.602 14.785h-81.758v-14.785c0-3.0938 2.5078-5.6016 5.5977-5.6016h70.562c1.4844 0 2.9102 0.58984 3.957 1.6406 1.0508 1.0508 1.6406 2.4766 1.6406 3.9609z"/>
                </svg>
              }
            </Box>
          )
        })}
        <Box sx={{marginTop:"4px"}} onClick={() => { addStep() }}>
          <Box style={{display:'flex', alignItems:'center', cursor:'pointer'}}>
            <img src={addForAdmin} style={{width:"12px"}} />
            <span style={{fontSize:"12px", marginLeft:'5px'}}>Ajoutez un seuil</span>
          </Box>
        </Box>

      </Box>
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Catégories</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px", display:"flex", alignItems:"flex-start", flexWrap:"wrap", columnGap:"10px", rowGap:"6px"}}>
        {Object.keys(allCats)?.map((key, iCat)=> (
          <Box key={iCat + '_' +key} sx={{display:"flex", alignItems:"center", gap:"4px"}}>
            <input
              style={{display:'block', cursor:"pointer"}}
              name={key}
              type="checkbox"
              checked={format?.categorie?.filter(c => c.key === key).length > 0}
              onChange={handleCheckbox}
            />
            {key}
          </Box>
        ))}
      </Box>

      {format?.categorie?.map((cat,iCat) => {
        let ptsMax = 0
        let findPtsMax = allCats[cat?.key]
        if (findPtsMax) {
          ptsMax = findPtsMax.max
        }
        return (
          <React.Fragment key={iCat}>
            <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>
              {cat?.key}
              <span style={{fontWeight:"normal"}}> ({ptsMax}pts max)</span>
            </Box>
            <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
              <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                <Box>
                  Nom :
                </Box>
                <Box sx={{flex:1}}>
                  <input
                    value={cat?.title || ""}
                    style={{width:"100%"}}
                    onChange={(e) => {
                      let newCats = format?.categorie
                      newCats[iCat].title = e.target.value
                      superAdminContext?.onSequenceChange(
                        'categorie',
                        newCats,
                        superAdminContext?.adminPlayerIndexes
                      )
                    }}
                  />
                </Box>
              </Box>

              <Box sx={{border:"1px solid #2929292f", padding:"5px", marginTop:"5px"}}>

                {cat?.seuils?.map((step, iStep) => {
                  return (
                    <Box
                      sx={{
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        borderBottom:"1px solid #BABABA",
                        "&:hover" : {
                          ".svgDelete" : {
                            opacity: "1 !important"
                          }
                        }
                      }}
                      key={iStep}
                    >
                      <Box sx={{
                        paddingTop:"2px",
                        paddingBottom:"2px",
                        display:"flex",
                        alignItems:"center"
                      }}>
                        <svg
                          style={{fill : iStep === categoriesIndexes[cat?.key] ? "green" : "silver", cursor:"pointer"}}
                          onClick={() => {
                            let newResults = {...results}
                            newResults[cat?.key].score = step?.seuil
                            setResults(newResults)
                          }}
                          width="20" height="20" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="m348.41 504.58c186.98 0 342.3-182.57 342.3-182.57 12.148-13.004 12.488-34.48 0.38281-47.59 0 0-147.64-182.07-341.07-182.07-193.43 0-341.07 182.07-341.07 182.07-11.938 13.281-12 34.836 0.21094 47.789 0 0 152.27 182.37 339.25 182.37zm1.6133-60.621c80.121 0 145.07-65.137 145.07-145.49 0-80.352-64.953-145.49-145.07-145.49-80.125 0-145.07 65.141-145.07 145.49 0 80.352 64.949 145.49 145.07 145.49zm0-80.828c35.609 0 64.477-28.949 64.477-64.66 0-35.711-28.867-64.664-64.477-64.664-35.609 0-64.48 28.953-64.48 64.664 0 35.711 28.871 64.66 64.48 64.66z" fillRule="evenodd"/>
                        </svg>
                        <span style={{fontSize:"14px", marginLeft:'7px'}}> ≥ : </span>
                        <input
                          value={step?.seuil}
                          style={{marginLeft:"7px", width:"160px", fontSize:"12px", marginRight:"3px", width:"42px"}}
                          type="number"
                          onBlur={() => { updateCatOrder(iCat) }}
                          onChange={(e) => {
                            handleCategorieSeuil(e.target.value ? parseInt(e.target.value): 0, iCat, iStep)
                          }}
                        />
                        <span>%</span>
                      </Box>
                      {cat.seuils.length > 1 &&
                        <svg className="svgDelete" style={{fill:"silver", opacity:0, cursor:"pointer"}} onClick={()=> { removeCategoryStep(iCat, iStep) }} width="20" height="20" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" >
                          <path d="m491.51 177.63h-283.02c-4.8047-0.03125-9.3945 1.9961-12.605 5.5742-3.2148 3.5742-4.7383 8.3555-4.1953 13.129l28 244.5c2.0234 17.77 10.516 34.176 23.859 46.086 13.348 11.906 30.609 18.488 48.492 18.48h120.57c18.113 0 35.574-6.7539 48.973-18.945 13.402-12.188 21.777-28.934 23.488-46.965l23.188-243.49c0.44141-4.7188-1.1328-9.4062-4.332-12.906s-7.7305-5.4844-12.469-5.4609z"/>
                          <path d="m424.48 93.801c0-10.398-4.1289-20.367-11.48-27.719-7.3516-7.3516-17.324-11.48-27.719-11.48h-70.562c-10.395 0-20.367 4.1289-27.719 11.48-7.3516 7.3516-11.48 17.32-11.48 27.719v14.785h-124.77v33.602l398.49-0.003906v-33.602l-124.77 0.003907zm-33.602 14.785h-81.758v-14.785c0-3.0938 2.5078-5.6016 5.5977-5.6016h70.562c1.4844 0 2.9102 0.58984 3.957 1.6406 1.0508 1.0508 1.6406 2.4766 1.6406 3.9609z"/>
                        </svg>
                      }
                    </Box>
                  )
                })}
                <Box sx={{marginTop:"4px"}} onClick={() => { addCategoryStep(iCat) }}>
                  <Box style={{display:'flex', alignItems:'center', cursor:'pointer'}}>
                    <img src={addForAdmin} style={{width:"12px"}} />
                    <span style={{fontSize:"12px", marginLeft:'5px'}}>Ajoutez un seuil</span>
                  </Box>
                </Box>

              </Box>
            </Box>
          </React.Fragment>
        )
      })}
    </>
  )
};

export default DiagHelper;
